const baseURL = "https://rr-api.realisticrealtors.com/api/rr";
export default baseURL;
